
import { computed } from 'vue'
export default {
    props: {
        direction: String,
        title: String,
        desc: String,
        image: String,
    },

    setup(props: any) {
        const directionFlex = computed(
            ()=>{
                return props.direction == 'column' ? 'flex-direction: column; width: 50%' : (
                    'flex-direction: row; width: 90%;'
                )
            }
        )
        
        const containerStyle = computed(
            ()=>{
                return props.direction == 'column' ? 'text-align: center;' : (
                    'text-align: start; '
                )
            }
        )

        const textStyle = computed(
            ()=>{
                return props.title.includes('Stay') ? 'text-align: center' : (
                    ''
                )
            }
        )

        return {
            directionFlex, containerStyle, textStyle
        }
    }
}
